import { Dispatch } from 'react-redux';
import l10n from '@built/i18n';
import { StoreState } from '../types/index';

export const SIGNAL_LANGUAGE_READY = 'SIGNAL_LANGUAGE_READY';
export const INITIALIZE_LANGUAGE = 'INITIALIZE_LANGUAGE';

export const signalLanguageReady = () => ({ type: SIGNAL_LANGUAGE_READY });
export const initializeLanguage = () => ({ type: INITIALIZE_LANGUAGE });

export interface SignalLanguageReady {
  type: typeof SIGNAL_LANGUAGE_READY;
}

export interface InitializeLanguage {
  type: typeof INITIALIZE_LANGUAGE;
}

export type LanguageAction = SignalLanguageReady | InitializeLanguage;

export const initializeI18n = (
  i18n: typeof l10n,
  dispatch: Dispatch<StoreState>
) => {
  dispatch(initializeLanguage());
  i18n.on('initialized', () => {
    dispatch(signalLanguageReady());
  });
};
